import { withStyles, Button } from '@material-ui/core';
import styles from '../styles';

const Action = ({
  classes,
  onAdd,
  onCancel,
  onSubmit,
  disabledCancel,
  disabledAdd,
  disableSubmit,
  isBobtailSelected,
}) => {
  return (
    <div className={classes.actionButtons}>
      {isBobtailSelected ? null : (
        <>
          <Button
            color="primary"
            variant="outlined"
            className={classes.confirmButton}
            onClick={onCancel}
            disabled={disabledCancel}
            classes={{
              root: classes.confirmButton,
              disabled: classes.disabledConfirmButton
            }}>
            CANCEL
          </Button>
          <Button
            color="primary"
            variant="outlined"
            className={classes.confirmButton}
            disabled={disabledAdd}
            onClick={onAdd}
            classes={{
              root: classes.confirmButton,
              disabled: classes.disabledConfirmButton
            }}>
            ADD TRAILER
          </Button>
        </>
      )}
      <Button
        color="primary"
        variant="contained"
        className={classes.confirmButton}
        onClick={onSubmit}
        disabled={disableSubmit}
        classes={{
          root: classes.confirmButton,
          disabled: classes.disabledConfirmButton
        }}>
        HOOK
      </Button>
    </div>
  );
};

export default withStyles(styles)(Action);
